// This is a small UI component which is displayed as an overlay on the pages that are only available
// on mobile devices. it is imported inside desktop only pages and the displaying is handled
// through the DesktopOnlyOverlay.scss imported at the top level of this file.

import React from "react";
import "../../../../../Assets/Styles/DesktopOnlyOverlay.scss";
import Logo from "../../../../../Assets/Images/Logo-small.svg";
import Banner from "../../../../../Assets/Images/DesktopOnly.svg";

const DesktopOnlyOverlay = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <div className="desktop-only-overlay">
      <img alt="CX" src={Logo} className="cx-logo" />
      <img alt="" src={Banner} className="banner-image" />
      <h1>{translateText("desktop_only_title")}.</h1>
      <p>{translateText("desktop_only_text")}.</p>
    </div>
  );
};
export default DesktopOnlyOverlay;
